export const createQuestion = `
mutation createQuestion ($input: QuestionUpsert!) {
    createQuestion (input: $input) {
        id
        createdAt
        updatedAt
    }
}
`;
